import { Image } from "rebass/styled-components";
import { useRef, memo } from "react";
import { Top5WidgetViewModel } from "./ViewModel";
import { analytics } from "../../Analytics";
import videojs from "video.js";
import {
  WidgetContainer,
  ClipSection,
  LogoSection,
  ViewNowButton,
  ClipPlayerContainer,
} from "./styledComponents";
import { PlayersList } from "./PlayersList";
import { VideoPlayer } from "../../VideoPlayer";
import { countClipImpression } from "MVVM/Utilities/Clip";

const { REACT_APP_S3_CLIP_BUCKET } = process.env;

const Top5Widget = memo(() => {
  const { loading, clip } = Top5WidgetViewModel();
  const videoPlayerRef = useRef<videojs.Player | null>(null);

  const handleViewNowClick = () => {
    analytics.track("Button Click", {
      button_name: "View Now",
      location: "top_5_widget",
      source: "logo_section",
    });
  };

  if (loading || !clip) return <></>;

  return (
    <WidgetContainer>
      <LogoSection>
        <Image
          src={`${REACT_APP_S3_CLIP_BUCKET}/static/web/top5/top5logo.png`}
          alt="Top 5 Logo"
        />
        <ViewNowButton
          to={`/clip/${clip.shareId}`}
          onClick={handleViewNowClick}
        >
          View Now
        </ViewNowButton>
      </LogoSection>
      <ClipSection>
        <ClipPlayerContainer>
          <VideoPlayer
            id="video_wrapper"
            refForVideoPlayer={videoPlayerRef}
            mp4Source={clip.url}
            loop={true}
            onPlayStart={() => countClipImpression(clip.shareId)}
            playAnalyticsProperties={{
              shareId: clip.shareId,
              clipId: clip.id,
              clipOwner: clip.user,
              total_views: clip.views,
              game: clip.game,
            }}
            watchAnalyticsProperties={{
              clipId: clip.id,
              collection: "Top5Widget",
              collectionType: "Widget",
              item: clip.shareId,
              itemType: "Clip",
              action: "play",
            }}
            options={{
              controls: true,
              aspectRatio: "16:9",
              poster: clip.thumbnailStandardUrl,
              playsinline: true,
              autoplay: "muted",
            }}
          />
        </ClipPlayerContainer>
      </ClipSection>
      <PlayersList topPlayers={clip.associatedUsers} />
    </WidgetContainer>
  );
});

export { Top5Widget };
